<template>
    <section class=" section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <h1 style="color: white">Giới thiệu</h1>
                        <p class="lead text-white mt-4 mb-5">Octa là doanh nghiệp cung cấp dịch vụ viễn thông quy mô lớn nhất Việt Nam. Nhà phân phối hàng đầu cung cấp các sản phẩm và dịch vụ viễn thông, game của tất cả các đơn vị viễn thông và nhà phát hành game trên toàn quốc.</p>
                    
                            <!--
                            <base-button tag="a"
                                         href="https://demos.creative-tim.com/argon-design-system/docs/components/alerts.html"
                                         class="mb-3 mb-sm-0"
                                         type="info"
                                         icon="fa fa-code">
                                Components
                            </base-button>
                            <base-button tag="a"
                                         href="https://www.creative-tim.com/product/argon-design-system"
                                         class="mb-3 mb-sm-0"
                                         type="white"
                                         icon="ni ni-cloud-download-95">
                                Download HTML
                            </base-button>
                            -->
                    
                    </div>
                </div>
                <!--
                <div class="row align-items-center justify-content-around stars-and-coded">
                    <div class="col-sm-4">
                        <span class="text-white alpha-7 ml-3">Star us on</span>
                        <a href="https://github.com/creativetimofficial/argon-design-system" target="_blank" title="Support us on Github">
                            <img src="img/brand/github-white-slim.png" style="height: 22px; margin-top: -3px">
                        </a>
                    </div>
                    <div class="col-sm-4 mt-4 mt-sm-0 text-right">
                        <span class="text-white alpha-7">Coded by</span>
                        <a href="https://www.creative-tim.com" target="_blank" title="Creative Tim - Premium Bootstrap Themes and Templates">
                            <img src="img/brand/creativetim-white-slim.png" class="ml-3" style="height: 30px;">
                        </a>
                    </div>
                </div>
                -->
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
